import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { SectionDto, ChapterListItem } from '@shared/types';

export function useSections() {
  return useQuery({
    queryKey: ['sections'],
    queryFn: () => api.get<{ sections: SectionDto[] }>('/sections'),
  });
}

export function useSectionChapters(sectionId: string | undefined) {
  return useQuery({
    queryKey: ['sections', sectionId, 'chapters'],
    queryFn: () => api.get<{ chapters: ChapterListItem[] }>(`/sections/${sectionId}/chapters`),
    enabled: !!sectionId,
  });
}
